<template>
  <path
    d="M18 4.00024V3.00024C18 2.45024 17.55 2.00024 17 2.00024H5C4.45 2.00024 4 2.45024 4 3.00024V7.00024C4 7.55024 4.45 8.00024 5 8.00024H17C17.55 8.00024 18 7.55024 18 7.00024V6.00024H19V10.0002H10C9.45 10.0002 9 10.4502 9 11.0002V21.0002C9 21.5502 9.45 22.0002 10 22.0002H12C12.55 22.0002 13 21.5502 13 21.0002V12.0002H20C20.55 12.0002 21 11.5502 21 11.0002V5.00024C21 4.45024 20.55 4.00024 20 4.00024H18Z"
  />
</template>
